import { useMemo } from 'react';

import { useShopProvider } from '#provider/useShopProvider.js';
import { useFeatureFlag_Core } from 'core';

/**
 * Hook to check if the consolidated checkout feature is enabled,
 * combines the feature flag and the shop provider flag
 */
const useWithConsolidatedCheckout = () => {
  const { isFeatureEnabled: isConsolidatedCheckoutFeatureFlagEnabled } = useFeatureFlag_Core({
    featureId: 'user.consolidatedCheckout',
  });
  const { isConsolidatedCheckoutEnabled } = useShopProvider();
  const isFeatureEnabled = useMemo(() => {
    return isConsolidatedCheckoutFeatureFlagEnabled && isConsolidatedCheckoutEnabled;
  }, [isConsolidatedCheckoutFeatureFlagEnabled, isConsolidatedCheckoutEnabled]);

  return {
    isEnabled: isFeatureEnabled,
  };
};

export { useWithConsolidatedCheckout };
